import { ENV } from './environment'

function getRequirePhoneNumber(): string {
  if (ENV === 'prod') {
    return 'itp-112_dtc_census_require_phone_number'
  } else {
    return 'itp-009_test-legacy'
  }
}
export const REQUIRE_PHONE_NUMBER = getRequirePhoneNumber()

export const PPI_243_ESIG_PAGE = 'ppi-243_esig_agents' as const
export const PPI_243_ESIG_PAGE_VARIANTS = {
  CONTROL: 'control',
  ESIG_ENABLED: 'esig-enabled'
} as const

export const PPI_27_ESIG_CHECKOUT = 'ppi-27-esignature' as const
export const PPI_27_ESIG_CHECKOUT_VARIANTS = {
  OFF: 'off',
  ON: 'on'
} as const

export const PPI_565_BY_PASS_QUOTE = 'ppi-565_by_pass_quote' as const
export const PPI_565_BY_PASS_QUOTE_VARIANTS = {
  CONTROL: 'control',
  BYPASS_ENABLE: 'bypass_enable'
} as const

export const PPI_330_ADDITIONAL_PRODUCTS_TAB = 'ppi-330_additional_products_tab'
export const PPI_330_ADDITIONAL_PRODUCTS_TAB_VARIANTS = {
  CONTROL: 'control',
  ADDITIONAL_PRODUCTS_TAB: 'additional_products_tab'
}

export const PPI_608_QUOTES_REBRANDING = 'ppi-608_quotes_rebranding'
export const PPI_608_QUOTES_REBRANDING_VARIANTS = {
  CONTROL: 'control',
  REBRANDING: 'rebranding'
}

export const PH_DEACTIVATE_MULTICARRIER_PLANS = 'ph_deactivate_multicarrier_plans'
export const PH_DEACTIVATE_MULTICARRIER_PLANS_VARIANTS = {
  OFF: 'off',
  ON: 'on'
}

export const PPI_1026_V2_DENTAL_PLAN_DETAILS = 'ppi-1026-v2-dental-plan-details' as const
export const PPI_1026_V2_DENTAL_PLAN_DETAILS_VARIANTS = {
  OFF: 'off',
  ON: 'on'
} as const

export const PPI_1142_FLEX_BENEFIT = 'ppi_1142_flex_benefit'
export const PPI_1142_FLEX_BENEFIT_VARIANTS = {
  OFF: 'off',
  ON: 'on'
}
